import * as React from 'react';
const SvgSecure = (props) => (
  <svg viewBox="0 0 124 124" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M82.87 88.087c0-2.87-2.348-5.218-5.218-5.218H46.348c-2.87 0-5.218 2.348-5.218 5.218v28.696c0 2.869 2.348 5.217 5.218 5.217h31.304c2.87 0 5.218-2.348 5.218-5.217V88.087Z"
      stroke="#000"
      strokeWidth={4}
      strokeMiterlimit={10}
    />
    <path
      d="M75.043 75.043C75.043 67.74 69.304 62 62 62c-7.304 0-13.044 5.74-13.044 13.043v7.827h26.087v-7.827ZM62 111.565V101.13M122 22.87H2M101.13 12.435h-7.826M114.174 12.435h-7.826M88.087 12.435H80.26M56.783 12.435H9.826M30.695 33.304h-18.26v18.261h18.26v-18.26Z"
      stroke="#000"
      strokeWidth={4}
      strokeMiterlimit={10}
    />
    <path
      d="M90.696 98.522H122V2H2v96.522h31.304M38.522 35.913h26.087M38.522 46.348h7.826M51.565 46.348h28.696"
      stroke="#000"
      strokeWidth={4}
      strokeMiterlimit={10}
    />
  </svg>
);
export default SvgSecure;
